export default "/_next/static/images/94d9c12367b6206bb825c2b7d09348dd.jpg";